import { useSpaceStore } from '../../stores/prioritization/spaceStore';
import { useWorkspaceType, type WorkspaceType } from '../../lib/workspaceModulesService';
import type { SpaceType } from '../../types/prioritization/collaborationSpaces';

export type SpaceKind = SpaceType | WorkspaceType;

/**
 * The kind of place the person is working in: the current space's type when a
 * space is selected, otherwise the workspace's type. Null until known.
 *
 * Both side menus read this — the full menu (Sidebar) to hide enterprise areas
 * in personal and team spaces, and the role-based menu to leave out Plans in a
 * personal space — so they never disagree about where the person is.
 */
export function useSpaceKind(): SpaceKind | null {
  const currentSpaceType = useSpaceStore((s) => s.getCurrentSpace()?.spaceType ?? null);
  const workspaceType = useWorkspaceType();
  return currentSpaceType ?? workspaceType;
}

/**
 * A small space is a personal or a team space. There the full side menu is the
 * small-space menu: it leaves out Strategy, Relationships and Reports, and the
 * settings groups meant for an organization. (Called "simplified mode" before
 * 2026-10-14.) Not the role-based menu, which is the short menu a member gets
 * from their roles — see `buildRoleMenu`.
 */
export function isSmallSpaceKind(kind: SpaceKind | null | undefined): boolean {
  return kind === 'personal' || kind === 'team';
}
